<template>
  <div class="terms-document">
    <p class="update-date"><strong>Última actualización:</strong> Diciembre 2025</p>
    
    <div class="accordion" role="tablist">
      <!-- 1. Aceptación de Términos -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-1 class="btn-accordion text-left">
            1. Aceptación de los Términos y Condiciones
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Al descargar, acceder o utilizar la aplicación móvil GOX (Puntos GOX) y sus servicios asociados, 
              aceptas estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con alguna parte 
              de estos términos, no debes utilizar nuestra aplicación o servicios.
            </b-card-text>
            <b-card-text>
              Estos términos constituyen un acuerdo legal vinculante entre tú (el "Usuario") y GOX 
              (el "Programa" o "Nosotros").
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 2. Descripción del Servicio -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-2 class="btn-accordion text-left">
            2. Descripción del Servicio GOX
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              GOX es un programa de fidelización que permite a los usuarios:
            </b-card-text>
            <ul>
              <li>Acumular puntos por compras realizadas en establecimientos afiliados</li>
              <li>Canjear puntos por cupones, descuentos y beneficios exclusivos</li>
              <li>Acceder a promociones especiales de nuestros socios comerciales</li>
              <li>Gestionar su perfil y transacciones a través de la aplicación móvil</li>
              <li>Referir amigos y ganar puntos adicionales</li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 3. Registro y Cuenta -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-3 class="btn-accordion text-left">
            3. Registro y Cuenta de Usuario
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              <strong>3.1 Requisitos:</strong> Debes ser mayor de 18 años para crear una cuenta. Al registrarte, 
              garantizas que toda la información proporcionada es veraz, precisa y actualizada.
            </b-card-text>
            <b-card-text>
              <strong>3.2 Responsabilidad:</strong> Eres responsable de mantener la confidencialidad de tu cuenta 
              y contraseña. Notifícanos inmediatamente si detectas uso no autorizado.
            </b-card-text>
            <b-card-text>
              <strong>3.3 Una cuenta por persona:</strong> Cada usuario puede tener solo una cuenta activa. 
              La creación de cuentas múltiples puede resultar en la suspensión de todas ellas.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 4. Acumulación de Puntos -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-4 class="btn-accordion text-left">
            4. Acumulación de Puntos GOX
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              <strong>4.1 Obtención:</strong> Los puntos se acumulan por compras realizadas en establecimientos 
              afiliados. Cada establecimiento define su propia tasa de conversión (soles a puntos).
            </b-card-text>
            <b-card-text>
              <strong>4.2 Separación por establecimiento:</strong> Los puntos acumulados en cada establecimiento 
              son independientes y se gestionan por separado, salvo convenios específicos entre establecimientos.
            </b-card-text>
            <b-card-text>
              <strong>4.3 Validación:</strong> Los puntos se acreditan después de que la transacción sea 
              validada por el establecimiento. Esto puede tomar entre 24 y 72 horas.
            </b-card-text>
            <b-card-text>
              <strong>4.4 Puntos adicionales:</strong> Puedes ganar puntos extras mediante:
            </b-card-text>
            <ul>
              <li>Promociones especiales</li>
              <li>Referidos exitosos</li>
              <li>Campañas de multiplicación de puntos</li>
              <li>Actividades promocionales en la app</li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 5. Canje de Puntos -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-5 class="btn-accordion text-left">
            5. Canje de Puntos y Cupones
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              <strong>5.1 Cupones:</strong> Los puntos pueden canjearse por cupones disponibles en la aplicación. 
              Cada cupón tiene términos y condiciones específicos.
            </b-card-text>
            <b-card-text>
              <strong>5.2 Activación:</strong> Debes activar el cupón en la app antes de utilizarlo. 
              Una vez activado, los puntos se retienen hasta que el cupón sea usado o expire.
            </b-card-text>
            <b-card-text>
              <strong>5.3 Validación:</strong> Presenta el código QR o código de barras del cupón activado 
              en caja para hacer efectivo el beneficio.
            </b-card-text>
            <b-card-text>
              <strong>5.4 No reembolsables:</strong> Los puntos y cupones canjeados no son reembolsables 
              ni transferibles. Si un cupón no se utiliza antes de su vencimiento, los puntos retornarán 
              a tu cuenta disponible.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 6. Vigencia de Puntos -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-6 class="btn-accordion text-left">
            6. Vigencia y Vencimiento de Puntos
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Los puntos GOX tienen una vigencia de <strong>3 años</strong> contados desde la fecha 
              en que fueron acreditados. Después de este período, los puntos vencen automáticamente 
              y no pueden ser recuperados.
            </b-card-text>
            <b-card-text>
              Recibirás notificaciones antes del vencimiento de tus puntos para que puedas utilizarlos.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 7. Programa de Referidos -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-7 class="btn-accordion text-left">
            7. Programa de Referidos
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Puedes invitar amigos a unirse a GOX y ganar puntos cuando ellos se registren y 
              realicen su primera compra en un establecimiento afiliado. Los términos específicos 
              de cada campaña de referidos se comunicarán en la aplicación.
            </b-card-text>
            <b-card-text>
              El abuso del programa de referidos (crear cuentas falsas, etc.) resultará en la 
              suspensión de la cuenta y pérdida de todos los puntos.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 8. Uso Apropiado -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-8 class="btn-accordion text-left">
            8. Uso Apropiado del Servicio
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text><strong>No está permitido:</strong></b-card-text>
            <ul>
              <li>Usar la aplicación para actividades ilegales o fraudulentas</li>
              <li>Intentar hackear, comprometer o interferir con el funcionamiento de la plataforma</li>
              <li>Crear múltiples cuentas o usar bots para acumular puntos</li>
              <li>Transferir o vender puntos a terceros</li>
              <li>Realizar ingeniería inversa de la aplicación</li>
              <li>Abusar del programa de referidos o promociones</li>
            </ul>
            <b-card-text>
              El incumplimiento de estas reglas puede resultar en la suspensión o terminación 
              de tu cuenta y la pérdida de todos los puntos acumulados.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 9. Modificaciones -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-9 class="btn-accordion text-left">
            9. Modificaciones al Servicio y Términos
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Nos reservamos el derecho de modificar, suspender o descontinuar cualquier aspecto 
              del servicio GOX en cualquier momento, incluyendo:
            </b-card-text>
            <ul>
              <li>Tasas de acumulación de puntos</li>
              <li>Catálogo de cupones y beneficios disponibles</li>
              <li>Establecimientos afiliados</li>
              <li>Funcionalidades de la aplicación</li>
            </ul>
            <b-card-text>
              También podemos actualizar estos Términos y Condiciones. Te notificaremos sobre 
              cambios significativos a través de la aplicación o por correo electrónico.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 10. Limitación de Responsabilidad -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-10 class="btn-accordion text-left">
            10. Limitación de Responsabilidad
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              <strong>10.1</strong> GOX actúa como intermediario entre usuarios y establecimientos afiliados. 
              No somos responsables por la calidad de productos o servicios adquiridos en estos establecimientos.
            </b-card-text>
            <b-card-text>
              <strong>10.2</strong> No garantizamos la disponibilidad ininterrumpida de la aplicación 
              y no seremos responsables por pérdidas derivadas de interrupciones del servicio.
            </b-card-text>
            <b-card-text>
              <strong>10.3</strong> Los establecimientos afiliados pueden salir del programa en cualquier 
              momento. En tal caso, se te notificará y tendrás un plazo razonable para canjear tus puntos.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 11. Suspensión y Terminación -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-11 class="btn-accordion text-left">
            11. Suspensión y Terminación de Cuenta
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              <strong>11.1 Por tu parte:</strong> Puedes cerrar tu cuenta en cualquier momento desde 
              la configuración de la aplicación o contactándonos. Los puntos no utilizados se perderán.
            </b-card-text>
            <b-card-text>
              <strong>11.2 Por nuestra parte:</strong> Podemos suspender o terminar tu cuenta si:
            </b-card-text>
            <ul>
              <li>Violas estos Términos y Condiciones</li>
              <li>Detectamos actividad fraudulenta o sospechosa</li>
              <li>Tu cuenta permanece inactiva por más de 2 años</li>
              <li>Es requerido por ley o autoridades competentes</li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 12. Contacto y Soporte -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-12 class="btn-accordion text-left">
            12. Contacto y Atención al Cliente
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Para consultas, soporte técnico o reclamos relacionados con el programa GOX, 
              puedes contactarnos:
            </b-card-text>
            <ul>
              <li><strong>Correo electrónico:</strong> <a href="mailto:atencionalcliente@puntosgox.com">atencionalcliente@puntosgox.com</a></li>
              <li><strong>Sitio web:</strong> <a href="https://puntosgox.com" target="_blank">www.puntosgox.com</a></li>
            </ul>
            <b-card-text>
              Nuestro horario de atención es de lunes a viernes de 9:00 a 18:00 horas.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 13. Ley Aplicable -->
      <b-card no-body class="mb-1 no-border">
        <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
          <b-button block v-b-toggle.accordion-13 class="btn-accordion text-left">
            13. Ley Aplicable y Jurisdicción
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
          <b-card-body class="accordion-body">
            <b-card-text>
              Estos Términos y Condiciones se rigen por las leyes de la República del Perú. 
              Cualquier disputa se resolverá en los tribunales de Lima, Perú, renunciando 
              expresamente a cualquier otro fuero que pudiera corresponder.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'section-accordion-terms',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped>
.terms-document {
  font-family: 'Raleway', sans-serif;
}

.update-date {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 2rem;
  font-style: italic;
}

.accordion-body {
  line-height: 1.8;
  color: #333;
}

.accordion-body ul {
  margin-left: 1.5rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}

.accordion-body ul li {
  margin-bottom: 0.5rem;
}

.accordion-body a {
  color: #e74c3c;
  text-decoration: none;
  font-weight: 600;
}

.accordion-body a:hover {
  text-decoration: underline;
}
</style>


